import type { GetImpactRatingAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetImpactRatingAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingAuditByIdArgs = {
  id: string;
};

export const useGetImpactRatingAuditById = createQueryHook<
  UseGetImpactRatingAuditByIdArgs,
  GetImpactRatingAuditByIdResponseRow[],
  GetImpactRatingAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impactRating.impactRatingAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating_audit: data }),
  graphqlDocument: GetImpactRatingAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
